<template>
  <div>
    <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
      <h3>{{ $lang('收件人信息') }}</h3>
      <div class="group-content">
        <el-form-item :label="$lang('姓名')" prop="receiverName">
          <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
          <BasePhoneInput :value="phoneVal2" :maxlength="16" v-model="formData.receiverMobilePhone"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('收件人备用手机号码')" prop="receiverTelphone">
          <BasePhoneInput :value="receiverTelphone" :maxlength="16" v-model="formData.receiverTelphone"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('公司')" prop="receiverCompany">
          <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20" />
        </el-form-item>
        <el-form-item :label="$lang('邮编')">
          <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('邮箱')">
          <el-input v-model.trim="formData.receiverEmail" :minlength="1" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="receiverProvinceName" prop="receiverProvinceName">
          <el-select filterable v-model="formData.receiverProvinceName" :key="formData.receiverProvinceId" @change="changeProvince($event)">
            <el-option v-for="item in provinceArray" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="receiverCityName" prop="receiverCityName">
          <el-select filterable v-model="formData.receiverCityName" :key="formData.receiverCityId" @change="changeCity($event)">
            <el-option v-for="item in cityList" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
          <el-input v-model.trim="formData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
          <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="200"></el-input>
        </el-form-item>
      </div>
      <h3>{{ $lang('货物信息') }}</h3>
      <div class="group-content">
        <el-form-item :label="$lang('件数')" prop="packageNumber">
          <el-input-number v-model="formData.packageNumber" label="描述文字" :step="1" :precision="0" :min="1" :max="999"></el-input-number>
        </el-form-item>
        <el-form-item :label="$lang('物品类型')" prop="goods">
          <Base-Select
            v-model="formData.goods"
            :props="{ label: 'name', value: 'code', res: 'appArticleTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
            @change="changeGoods"
          ></Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('物品名称')" prop="goodsName">
          <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
          <el-input-number v-model="formData.packageTotalWeight" label="描述文字" :precision="2" :min="0" :max="30"></el-input-number>
        </el-form-item>
        <el-form-item :label="$lang('结算方式')" prop="payment">
          <Base-Select
            v-model="formData.payment"
            :disabled="true"
            :props="{ label: 'name', value: 'code', res: 'appPaymentMannerVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
          >
          </Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('支付方式')" prop="paidMode">
          <Base-Select
            v-model="formData.paidMode"
            :props="{ label: 'name', value: 'code', res: 'appPayTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
            :disabled="true"
          >
          </Base-Select>
        </el-form-item>
        <el-form-item :label="$lang('产品类型')" prop="expressType">
          <Base-Select
            v-model="formData.expressType"
            :props="{ label: 'productName', value: 'productCode', res: 'appProductTypeVOList', valueObj: true }"
            :dic="someExpressTypeData"
            :placeholder="$lang('请选择')"
          >
          </Base-Select>
          <!-- <Base-Select
            v-model="formData.expressType"
            :props="{ label: 'name', value: 'code', res: 'appProductTypeVOList', valueObj: true }"
            dicUrl="/vip/baseData/list"
            :placeholder="$lang('请选择')"
          >
          </Base-Select> -->
        </el-form-item>
        <el-form-item :label="$lang('参考运费')" prop="standardValue">
          <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="cod">
          <!-- <el-checkbox class="btn-insured" v-model="codFlag" @change="checkCod">{{ $lang('是否代收货款') }}</el-checkbox> -->
          <el-checkbox class="btn-insured" v-model="formData.codNeed" @change="checkCod">{{ $lang('是否代收货款') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
          <el-select :disabled="!formData.codNeed" v-model="formData.codCurrencyTypeName" @change="changeCodCurrency">
            <el-option v-for="item in codCurrencyType" :key="item.code" :label="item.enName" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
          <el-input
            :disabled="!formData.codNeed"
            v-model="formData.codMoney"
            :label="$lang('描述文字')"
            :placeholder="$lang('请输入对应的金额')"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            @blur="codMoneyBlur"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
          <el-input v-model="formData.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('平台')" prop="platformName">
          <el-input v-model.trim="formData.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1" :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('客户账号')" prop="customerAccount">
          <el-input class="customerStyle" v-model.trim="formData.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1" :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item style="width: auto; margin-top: 20px" prop="isUnpackEnabled">
          <el-switch v-model="formData.isUnpackEnabled" :active-text="$lang('是否允许客户开箱验视')"> </el-switch>
        </el-form-item>
        <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
          <!-- <a class="btn-insured" @click="openInsured">{{$lang('保价声明')}}</a> -->
          <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === 'PP_PM' " :placeholder="$lang('请选择')"  @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
          </el-form-item>
          <el-form-item :label="$lang('保险价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
            <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="0" :controls="false" :min="0" :max="99999"></el-input-number>
            <!-- <el-input  @keyup.enter.native="searchData(false)" v-model="formData.declaredValue" :placeholder="$lang('请输入')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
          </el-form-item>
          <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured===1">
          <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { RULES, checkAddressFormat, integerWeight, checkGoodsName, phoneAndMobile, isNull } from '@utils/rules'
import { mapGetters } from 'vuex'
import * as Api from '@api/base/public'
import { DIC } from '@constants'
import { getComCost, getSettlement, getsysCurrencyType, customerCod, getComputationCost } from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import _ from 'lodash'
export default {
  props: {
    rowData: {
      type: Object,
      default: _ => {
        return {}
      }
    }
  },
  data () {
    return {
      DIC,
      rules: {
        receiverName: [RULES.required, { validator: isNull }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        // receiverStreet: [RULES.requiredTrim],
        goods: [RULES.required],
        goodsName: [RULES.required, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        // paidMode: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        payment: [RULES.requiredSelect],
        isUnpackEnabled: [RULES.required],
        insured: [RULES.requiredSelect]

      },
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('省份'),
      senderCityName: this.$lang('寄件城市'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      provinceArray: [],
      cityList: [],
      codCurrencyType: [],
      phoneVal2: '',
      receiverTelphone: '',
      codFlag: false,
      codIsInput: true,
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      formData: {
        receiverName: '',
        receiverMobilePhone: '',
        receiverTelphone: '',
        receiverCompany: '',
        receiverPostalCode: '',
        receiverEmail: '',
        receiverProvinceName: '',
        receiverProvinceId: '',
        receiverCityName: '',
        receiverCityId: '',
        receiverStreet: '',
        receiverDetailedAddress: '',
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: 0, // 保价费,
        packageTotalWeight: '',
        codCurrencyTypeName: '',
        codCurrencyTypeCode: '', // 代收货款币别code
        codMoney: '',
        codFee: '',
        platformName: '',
        customerAccount: '',
        payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 }, // 结算方式
        paymentModeId: '42', // 结算方式id,
        paymentModeCode: 'PP_PM', // 结算方式编码,
        paymentModeName: this.$lang('Monthly'), // 结算方式名称,
        isUnpackEnabled: 0,
        expressType: '', // 产品类型
        expressTypeCode: '', // 产品类型code
        expressTypeName: '' // 产品类型name
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    countryCode () {
      return this.$store.state.base.user.countryCode || ''
    },
    calcStandardCostNum () {
      const { goodsTypeCode, expressType, payment, paidMode, receiverCityName, packageTotalWeight } = this.formData
      return {
        goodsTypeCode,
        expressType,
        payment,
        paidMode,
        receiverCityName,
        packageTotalWeight
      }
    },
    someExpressTypeData () {
      const { receiverExpressTypeData: arr1, senderExpressTypeData: arr2 } = this
      const someExpressTypeData = arr1.filter(item1 => arr2.some(item2 => item2.productId === item1.productId))
      return someExpressTypeData
    }
  },
  watch: {
    countryCode: {
      handler (val) {
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          this.senderProvinceName = this.$lang('寄件酋长国')
          this.senderCityName = this.$lang('寄件区域')
          this.receiverProvinceName = this.$lang('收件酋长国')
          this.receiverCityName = this.$lang('收件区域')
        }
      },
      immediate: true
    },
    rowData: {
      handler (obj) {
        console.log('详情数据------------>>', obj)
        // const { formData } = this
        // const newFormData = Object.keys(obj).reduce((acc, cur) => {
        //   if (formData.hasOwnProperty(cur)) {
        //     acc[cur] = obj[cur]
        //   }
        //   return acc
        // }, {})
        const goods = {
          id: obj.goodsTypeId,
          code: obj.goodsTypeCode,
          name: obj.goodsTypeName
        }
        const paidMode = {
          id: obj.paidModeId || '',
          code: obj.paidModeCode || '',
          name: obj.paidModeName || ''
        }
        const payment = {
          id: 42 || obj.paymentModeId,
          code: 'PP_PM' || obj.paymentModeCode,
          name: 'PP_PM' || obj.paymentModeName
        }
        let expressType = {
          productCode: obj.expressTypeCode, // 产品类型code
          productName: obj.expressTypeName // 产品类型name
        }
        if (Object.keys(expressType).some(key => !expressType[key])) expressType = ''
        obj.isUnpackEnabled = !!obj.isUnpackEnabled
        obj.codNeed = !!obj.codNeed
        this.formData = {
          // ...this.formData,
          // ...newFormData,
          ...obj,
          goods,
          payment,
          paidMode,
          expressType
        }
        this.getProvince()
        this.getCurrencyTypeList()
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler (val) {
        const params = _.cloneDeep(val)
        params.isUnpackEnabled = +params.isUnpackEnabled
        params.codNeed = +params.codNeed
        for (const key in params) {
          if (key.includes('Time') || key.includes('time')) delete params[key]
        }
        this.$emit('updateformData', params)
      },
      deep: true,
      immediate: true
    },
    calcStandardCostNum: {
      handler (newV, oldV) {
        if (!_.isEqual(newV, oldV)) {
          this.calcStandardCostBefore(this.formData)
        }
      },
      deep: true
    },
    someExpressTypeData: {
      handler (arr) {
        if (!arr.length) return
        const hasProduct = arr.some(item => item.productName === this.formData.expressTypeName)
        if (!hasProduct) {
          this.formData.expressType = ''
          this.formData.expressTypeCode = ''
          this.formData.expressTypeName = ''
        }
      },
      deep: true,
      immediate: false
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    }
    // 产品类型
    // async 'formData.expressType'(val) {
    //   const { productCode: expressTypeCode, productName: expressTypeName } = val
    //   // console.log('77777', expressTypeCode + ',' + expressTypeName)
    //   // const taxationVal = this.someExpressTypeData.find(item => item.code === expressTypeCode)
    //   // this.formData.taxation = taxationVal ? taxationVal.taxRate : 0
    //   // console.log('88888', this.formData.taxation)
    //   Object.assign(this.formData, { expressTypeCode, expressTypeName })
    //   const { senderCityName, receiverCityName, packageTotalWeight } = this.formData
    //   if (senderCityName && receiverCityName && val && packageTotalWeight > 0) {
    //     const res = await this.calcStandardCost(this.formData)
    //     // console.log(222222222)
    //     Object.assign(this.formData, res)
    //   }
    //   const res = await this.getComputationCost(this.formData)
    //   Object.assign(this.formData, { insuredValue: res })
    // }
  },
  methods: {
    codMoneyBlur () {
      const reg = /^(\d+)(.\d{0,2})?$/
      const codMoney = +this.formData.codMoney
      if (!reg.test(codMoney)) {
        this.$message.error(this.$lang('代收货款格式有误！'))
        this.formData.codMoney = 0
      }
      if (codMoney > 3000) {
        this.$message.error(`${this.$lang('代收货款金额超额，最高限额为')}3000`)
        this.formData.codMoney = 0
      }
    },
    // 获取酋长国数据
    async getProvince () {
      const { data, succ, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (succ) {
        this.provinceArray = data
        this.getCity(this.formData.receiverProvinceId)
        this.getSendCity(this.formData.senderProvinceId)
      } else {
        this.$message.error(msg)
      }
    },
    async getSendCity (parentId) {
      const { data, succ } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId })
      if (succ) {
        const obj = this.findDataObj(data, this.formData.senderCityId)
        this.senderExpressTypeData = (obj && obj.products) ? obj.products : []
      }
    },
    async getCity (parentId, setDefaultCity) {
      const { data, succ, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId })
      if (succ) {
        this.cityList = data
        if (setDefaultCity === 'setDefaultCity') {
          this.formData.receiverCityId = data[0].id
          this.formData.receiverCityName = data[0].nativeName
          this.receiverExpressTypeData = data[0].products || []
          if (this.someExpressTypeData && this.someExpressTypeData.length) {
            this.formData.expressType = this.someExpressTypeData[0]
            this.formData.expressTypeCode = this.someExpressTypeData[0].productCode
            this.formData.expressTypeName = this.someExpressTypeData[0].productName
          } else {
            this.formData.expressType = ''
            this.formData.expressTypeCode = ''
            this.formData.expressTypeName = ''
            if (this.receiverExpressTypeData.length && this.senderExpressTypeData.length) {
              this.$message.error(this.$lang('产品类型不匹配，无法下单'))
            }
          }
        } else {
          const obj = this.findDataObj(data, this.formData.receiverCityId)
          this.receiverExpressTypeData = (obj && obj.products) ? obj.products : []
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取币别
    async getCurrencyTypeList () {
      const { data, succ, msg } = await getsysCurrencyType()
      if (succ) {
        this.codCurrencyType = data
      } else {
        this.$message.error(msg)
      }
    },
    changeProvince (val) {
      const obj = this.findDataObj(this.provinceArray, val)
      this.formData.receiverProvinceId = val
      this.formData.receiverProvinceName = obj.nativeName
      this.getCity(val, 'setDefaultCity')
    },
    changeCity (val) {
      const obj = this.findDataObj(this.cityList, val)
      this.formData.receiverCityId = val
      this.formData.receiverCityName = obj.nativeName
      this.receiverExpressTypeData = obj.products
    },
    findDataObj (arr, val, key = 'id') {
      return arr.find(item => item[key] === val)
    },
    changeGoods (val) {
      const { code, id, name } = val
      this.formData.goodsTypeId = id
      this.formData.goodsTypeCode = code
      this.formData.goodsTypeName = name
    },
    changeCodCurrency (val) {
      const obj = this.findDataObj(this.codCurrencyType, val, 'code')
      this.formData.codCurrencyTypeCode = obj.code
      this.formData.codCurrencyTypeName = obj.name
    },
    // 是否代收货款
    async checkCod (val) {
      if (val) {
        const res = await customerCod({ customerCode: this.user.customerCode })
        if (res && res.data && res.data.isOpenCod === 1) {
          // this.formData.codCurrencyTypeName = 'SAR' // 代收货款币别
          // this.formData.codCurrencyTypeCode = 'SAR' // 代收货款币别code
          this.codNumber = res.data.maxCollectionMoney
          this.codIsInput = false
        } else {
          this.$message.error(this.$lang('您未开通代收货款服务，请联系合作网点！'))
        }
      } else {
        this.formData.codCurrencyTypeName = '' // 代收货款币别
        this.formData.codCurrencyTypeCode = '' // 代收货款币别code
        this.formData.codMoney = 0
        this.codIsInput = true
      }
    },
    /**
     * 是否保价
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = 0
      }
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement (providerId, cityId, packageTotalWeight, type) {
      const reqData = { providerId, cityId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost (number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 6:
            smModeType = 1
            break
          case 7:
            smModeType = 2
            break
          case 8:
            smModeType = 3
            break
        }
      }
      const { goodsTypeCode, senderCityId, receiverCityId } = this.formData
      const params = {
        value: number,
        startAddressId,
        endAddressId,
        smMode: smModeType,
        productTypeCode,
        goodsTypeCode,
        startCityId: senderCityId,
        endCityId: receiverCityId
      }
      // 服务方式-serviceMethodCode 写死寄件上门 01
      // const reqData = { startAddressId, endAddressId, number, productTypeCode, serviceMethodCode: '01', ...{ smMode: smModeType }}
      const { data = 0 } = await getComCost(params)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 运费查询
    async calcStandardCostBefore() {
      const { goodsTypeCode, senderProvinceId, receiverProvinceId, packageTotalWeight, expressTypeCode, paidModeCode } = this.formData
      if (senderProvinceId && receiverProvinceId && goodsTypeCode && packageTotalWeight > 0 && expressTypeCode && paidModeCode) {
        this.calcStandardCost(this.formData)
      }
    },
    // 运费计算
    async calcStandardCost (data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, packageTotalWeight, paymentModeId, expressTypeCode } = data
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId)
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId && expressTypeCode) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.result
        obj.settlementWeight = res.settValue
        this.formData = {
          ...this.formData,
          ...obj
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;
}
</style>
